import { create } from 'zustand';

const STORAGE_KEY = 'pw_audio_enabled';

interface AudioState {
  enabled: boolean;
  toggle: () => void;
  setEnabled: (v: boolean) => void;
}

const initial = (() => {
  if (typeof window === 'undefined') return true;
  const v = localStorage.getItem(STORAGE_KEY);
  return v === null ? true : v === 'true';
})();

export const useAudioStore = create<AudioState>((set) => ({
  enabled: initial,
  toggle: () =>
    set((s) => {
      const next = !s.enabled;
      localStorage.setItem(STORAGE_KEY, String(next));
      return { enabled: next };
    }),
  setEnabled: (v) => {
    localStorage.setItem(STORAGE_KEY, String(v));
    set({ enabled: v });
  },
}));
